/// <amd-module name="Repos/VersionDialogs/Components/Delete/DeleteBranchDialog" />
import * as React from "react";

import { ObservableValue } from "VSS/Core/Observable";
import { format } from "VSS/Core/Util/String";
import { Components, VssComponent } from "VSS/Platform/Layout";

import * as Resources from "Repos/VersionDialogs/Resources";

import { DialogResult, getService as getVersionDialogsService, IVersionDialogContext } from "../../VersionDialogsService";
import { IDeleteBranchDialogProps } from "./DeleteBranchDialog.Props";
import { DeleteDialog } from "./DeleteDialog";
import { IDeleteDialogProps } from "./DeleteDialog.Props";

export class DeleteBranchDialog extends VssComponent<IDeleteBranchDialogProps> {
    private deleteResult = new ObservableValue<DialogResult>({});

    public render(): JSX.Element {
        const { onComplete, onDismiss, repository, branchToDelete } = this.props;

        const deleteMessage = format(Resources.DeleteBranchConfirmationMessage, branchToDelete.version);

        const dialogProps: IDeleteDialogProps = {
            deleteMessage,
            deleteResult: this.deleteResult,
            dialogTitle: Resources.DeleteBranchDialogTitle,
            onDeleteClick: this.onDeleteClick,
            onDeleteComplete: onComplete,
            onDismiss,
            repository
        };

        return <DeleteDialog {...dialogProps} />;
    }

    private onDeleteClick = (): void => {
        const dialogContext: IVersionDialogContext = { dialogResult: this.deleteResult, repository: this.props.repository! };
        const { branchToDelete } = this.props;
        getVersionDialogsService(this.context.pageContext).deleteBranch(dialogContext, branchToDelete);
    };
}

Components.add("ms.vss-code-web.delete-branch-dialog", DeleteBranchDialog);
